import React from 'react'
import ReactDOM from 'react-dom'
import { default as q } from 'query-string'

import { storage } from './helpers'
import * as serviceWorker from './serviceworkers'

import './index.css'
import App from './App'

export class WhiteScreenErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { error: null, errorInfo: null }
  }
  
  componentDidCatch(error, errorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error: error,
      errorInfo: errorInfo
    })
    // You can also log error messages to an error reporting service here
  }
  
  render() {
    if (this.state.errorInfo) {
      // Error path
      return (
        <div>
          <h2>Something went wrong.</h2>
          <details style={{ whiteSpace: 'pre-wrap' }}>
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo.componentStack}
          </details>
        </div>
      )
    }
    // Normally, just render children
    return this.props.children
  }  
}

// catching referral link
const url = document.URL
const cookieRef =
  document.cookie.match(/gorod_ref=/) &&
  document.cookie.match(/gorod_ref=(.+)(;|$)/)[1]
const newInvitor =
  q.parseUrl(url).query.invite || q.parseUrl(url).query.u || cookieRef

storage.addInvitor(newInvitor)

const render = (Component) => {
  return ReactDOM.render(<WhiteScreenErrorBoundary><Component /></WhiteScreenErrorBoundary>, document.getElementById('root'))
}

render(App)

if (module.hot) {
  module.hot.accept('./App', (_) => {
    const NextApp = require('./App').default
    render(NextApp)
  })
}

serviceWorker.unregister()